export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/eae682daee3de638e9af1f5a046447ab.jpg"
          alt="Professional Pressure Cleaning"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/30 to-blue-900/50"></div>
      </div>

      {/* Diagonal Accent */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-br from-cyan-400/10 to-transparent transform skew-x-12 translate-x-1/4"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-4xl">
          {/* Eyebrow */}
          <div className="inline-block mb-6">
            <span className="text-cyan-300 text-sm font-bold uppercase tracking-widest">
              Premium Pressure Cleaning in Miami
            </span>
          </div>

          {/* Headline */}
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
            Pressure Cleaning That Makes Your Property Look{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-cyan-400 italic">
              Brand New
            </span>
          </h2>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-slate-200 leading-relaxed mb-10 max-w-2xl">
            X-Treme Aqua Pressure Cleaning delivers fast, detailed pressure cleaning across Miami—removing dirt, grime, mold, and stains for a fresh, upgraded look.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="tel:3052793585"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-orange-400 to-orange-500 text-white text-lg font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-fill mr-2"></i>
              Call Now
            </a>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-lg font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-file-list-3-line mr-2"></i>
              Get a Free Quote
            </button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center space-x-2 bg-white/95 backdrop-blur-sm px-5 py-3 rounded-full shadow-lg">
              <i className="ri-star-fill text-orange-400 text-xl"></i>
              <span className="text-blue-900 font-bold">5.0 ★ Rating</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/95 backdrop-blur-sm px-5 py-3 rounded-full shadow-lg">
              <i className="ri-time-line text-cyan-500 text-xl"></i>
              <span className="text-blue-900 font-bold">Open 24 Hours</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/95 backdrop-blur-sm px-5 py-3 rounded-full shadow-lg">
              <i className="ri-flashlight-fill text-cyan-500 text-xl"></i>
              <span className="text-blue-900 font-bold">Fast Response</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
}